import dayjs from "dayjs";
import "dayjs/locale/mn";
import "./App.css";
import { PublicEventsPage } from "./pages/PublicEventsPage";
import { BookingPage } from "./pages/BookingPage";
import { PaymentPage } from "./pages/PaymentPage";
import { AdminPage } from "./pages/AdminPage";
import { AdminAvailabilityPage } from "./pages/AdminAvailabilityPage";
import { AdminBookingsPage } from "./pages/AdminBookingsPage";
import { AdminContactsPage } from "./pages/AdminContactsPage";
import { AdminManualBookingPage } from "./pages/AdminManualBookingPage";
import { AdminPromoPage } from "./pages/AdminPromoPage";
import { AdminAuthGate } from "./components/admin/AdminAuthGate";

dayjs.locale("mn");

function App() {
  const path = window.location.pathname;

  if (path.startsWith("/admin/bookings")) return <AdminAuthGate><AdminBookingsPage /></AdminAuthGate>;
  if (path.startsWith("/admin/manual-booking")) return <AdminAuthGate><AdminManualBookingPage /></AdminAuthGate>;
  if (path.startsWith("/admin/promo")) return <AdminAuthGate><AdminPromoPage /></AdminAuthGate>;
  if (path.startsWith("/admin/availability")) return <AdminAuthGate><AdminAvailabilityPage /></AdminAuthGate>;
  if (path.startsWith("/admin/contacts")) return <AdminAuthGate><AdminContactsPage /></AdminAuthGate>;
  if (path.startsWith("/admin")) return <AdminAuthGate><AdminPage /></AdminAuthGate>;
  if (path.startsWith("/book/")) return <BookingPage eventId={path.split("/book/")[1]} />;
  if (path.startsWith("/payment")) return <PaymentPage />;
  if (path.startsWith("/portrait")) return <PublicEventsPage initialCategory="portrait" />;
  if (path.startsWith("/regular")) return <PublicEventsPage initialCategory="regular" />;
  return <PublicEventsPage  />;
}

export default App;
